import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import VuiPagination from "components/VuiPagination";
import Icon from "@mui/material/Icon";
import { useParams } from "react-router-dom";

function DataExport() {
  const { site_id } = useParams();
  const [siteData, setSiteData] = useState([]);
  const [stockedMaterialsData, setStockedMaterialsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);
  const [dialogOpen, setDialogOpen] = useState(true);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [includeStockedMaterials, setIncludeStockedMaterials] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedColumns([]);
      setSelectAll(false);
    } else {
      setSelectedColumns(columnsOptions);
      setSelectAll(true);
    }
  };

  const columnsOptions = [
    { label: "Daily Asphalt ", value: "Asphalt_Day" },
    { label: "Weekly Asphalt", value: "Asphalt_Week" },
    { label: "Monthly Asphalt", value: "Asphalt_Month" },
    { label: "Yearly Asphalt", value: "Asphalt_Year" },
    { label: "Daily RAP Total", value: "RAP_Total_Day" },
    { label: "Weekly RAP Total", value: "RAP_Total_Week" },
    { label: "Monthly RAP Total", value: "RAP_Total_Month" },
    { label: "Yearly RAP Total", value: "RAP_Total_Year" },
    { label: "Daily RAP Utilisation", value: "RAP_Utilisation_Day" },
    { label: "Weekly RAP Utilisation", value: "RAP_Utilisation_Week" },
    { label: "Monthly RAP Utilisation", value: "RAP_Utilisation_Month" },
    { label: "Yearly RAP Utilisation", value: "RAP_Utilisation_Year" },
    { label: "Electric Total", value: "Electric_Total" },
    { label: "Wasted Electricity", value: "Wasted_Elec" },
    { label: "Wasted Aggregate", value: "Wasted_Agg" },
    { label: "Wasted Fuel", value: "Wasted_Fuel" },
    { label: "Aggregate Total", value: "Agg_Total" },
    { label: "Bitumen Total", value: "Bit_Total" },
    { label: "Filler Total", value: "Filler_Total" },
    { label: "Additive Total", value: "Additive_Total" },
    { label: "RAP Total", value: "RAP_Total" },
    { label: "Gas Total", value: "Gas_Total" },
    { label: "Fuel Total", value: "Fuel_Total" },
    // { label: "Motor 1 Name", value: "Motor_1_Name" },
    // { label: "Motor 1 Current", value: "Motor_1_Current" },
    // { label: "Motor 1 Current Status", value: "Motor_1_Current_Status" },
    // { label: "Motor 1 Vibration Status", value: "Motor_1_Vibration_Status" },
    // { label: "Motor 1 Temperature", value: "Motor_1_Temperature" },
    // { label: "Motor 1 Temperature Status", value: "Motor_1_Temperature_Status" },
    // { label: "Motor 2 Name", value: "Motor_2_Name" },
    // { label: "Motor 2 Current", value: "Motor_2_Current" },
    // { label: "Motor 2 Current Status", value: "Motor_2_Current_Status" },
    // { label: "Motor 2 Vibration", value: "Motor_2_Vibration" },
    // { label: "Motor 2 Vibration Status", value: "Motor_2_Vibration_Status" },
    // { label: "Motor 2 Temperature", value: "Motor_2_Temperature" },
    // { label: "Motor 2 Temperature Status", value: "Motor_2_Temperature_Status" },
    // { label: "Gearbox 1 Name", value: "Gearbox_1_Name" },
    // { label: "Gearbox 1 Vibration", value: "Gearbox_1_Vibration" },
    // { label: "Gearbox 1 Vibration Status", value: "Gearbox_1_Vibration_Status" },
    // { label: "Gearbox 1 Temperature", value: "Gearbox_1_Temperature" },
    // { label: "Gearbox 1 Temperature Status", value: "Gearbox_1_Temperature_Status" },
    // { label: "Gearbox 2 Name", value: "Gearbox_2_Name" },
    // { label: "Gearbox 2 Vibration", value: "Gearbox_2_Vibration" },
    // { label: "Gearbox 2 Vibration Status", value: "Gearbox_2_Vibration_Status" },
    // { label: "Gearbox 2 Temperature", value: "Gearbox_2_Temperature" },
    // { label: "Gearbox 2 Temperature Status", value: "Gearbox_2_Temperature_Status" },
    { label: "Daily RAP Total", value: "RAP_Total_Day" },
    { label: "Weekly RAP Total", value: "RAP_Total_Week" },
    { label: "Monthly RAP Total", value: "RAP_Total_Month" },
    { label: "Gas Per Tonnage", value: "Gas_Per_Ton" },
    { label: "Fuel Per Tonnage", value: "Fuel_Per_Ton" },
    { label: "Electric Per Tonnage", value: "Elec_Per_Ton" },
    { label: "Plant Status", value: "Plant_Status" },
    { label: "Offline Hours", value: "Offline_Hrs" },
    { label: "Production Hours", value: "Production_Hrs" },
    { label: "Breakdown Hours", value: "Breakdown_Hrs" },
    { label: "Idle Hours", value: "Idle_Hrs" },
    { label: "Day Good Quality", value: "Day_Good_Quality" },
    { label: "Day Bad Quality", value: "Day_Bad_Quality" },
    { label: "Week Good Quality", value: "Week_Good_Quality" },
    { label: "Week Bad Quality", value: "Week_Bad_Quality" },
    { label: "Month Good Quality", value: "Month_Good_Quality" },
    { label: "Week Bad Quality", value: "Month_Bad_Quality" },
    { label: "Year Good Quality", value: "Year_Good_Quality" },
    { label: "Year Bad Quality", value: "Year_Bad_Quality" },
  ];

  useEffect(() => {
    const fetchSiteData = async () => {
      try {
        const response = await fetch(
          `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/site/profile?site_id=${site_id}`
        );
        const data = await response.json();
        setSiteName(data.name);
      } catch (error) {
        console.error("Error fetching site data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSiteData();
  }, [site_id]);

  const fetchSiteData = async (nextToken = null) => {
    try {
      setLoading(true);
      const gatewayName = await fetchGatewayName();
      if (!gatewayName) return;

      const startDateFormatted = dateRange.startDate;
      const endDateFormatted = dateRange.endDate;
      const columnValues = selectedColumns.map((col) => col.value).join(", ");

      const url = new URL(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/query-timestream`
      );
      url.searchParams.append("query_type", "data_export");
      url.searchParams.append("thing_name", gatewayName);
      url.searchParams.append("start_date", startDateFormatted);
      url.searchParams.append("end_date", endDateFormatted);
      if (columnValues) {
        url.searchParams.append("columns", columnValues);
      }
      if (nextToken) {
        url.searchParams.append("next_token", nextToken);
      }
      if (includeStockedMaterials) {
        url.searchParams.append("include_stocked_materials", "true");
      }

      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (includeStockedMaterials && data.stocked_materials) {
        const materialsMeta = data.stocked_materials.map((material) => ({
          index: material.index,
          key: `SM Name ${material.index}`,
          totalKey: `SM Total ${material.index}`,
        }));
        setStockedMaterialsData(materialsMeta);
      }

      // Process the data to include all columns
      const formattedData = data.rows.map((row) => {
        const rowData = { "Date Time": new Date(row.time).toLocaleString() };

        selectedColumns.forEach((col, index) => {
          rowData[col.label] = row[`col_${index + 1}`] || "N/A";
        });

        if (includeStockedMaterials) {
          // Dynamically find all Material_X_Name and Material_X_Total keys
          Object.keys(row).forEach((key) => {
            if (key.startsWith("Material_") && (key.endsWith("_Name") || key.endsWith("_Total"))) {
              const parts = key.split("_");
              const index = parts[1];
              const type = parts[2]; // 'Name' or 'Total'

              if (type === "Name") {
                rowData[`SM Name ${index}`] = row[key] || "N/A";
              } else {
                rowData[`SM Total ${index}`] = row[key] || "N/A";
              }
            }
          });
        }

        return rowData;
      });

      if (nextToken) {
        setSiteData((prevData) => [...prevData, ...formattedData]);
      } else {
        setSiteData(formattedData);
      }

      if (data.next_token) {
        await fetchSiteData(data.next_token);
      }
    } catch (error) {
      console.error("Error fetching data export:", error);
    } finally {
      setLoading(false);
    }
  };

  // Generate table columns dynamically based on the first row of data
  const generateTableColumns = () => {
    if (siteData.length === 0) return [{ name: "Date Time", align: "left" }];

    const columns = [{ name: "Date Time", align: "left" }];

    // Add selected columns
    selectedColumns.forEach((col) => {
      columns.push({ name: col.label, align: "center" });
    });

    // Add stocked materials columns if they exist in the first row
    const firstRow = siteData[0];
    Object.keys(firstRow).forEach((key) => {
  if ((key.startsWith("SM Name") || key.startsWith("SM Total")) && !columns.some((col) => col.name === key)) {
    columns.push({ name: key, align: "center" });
  }
});

    return columns;
  };

  const fetchGatewayName = async () => {
    try {
      const response = await fetch(
        `https://5d7600h5g2.execute-api.eu-west-2.amazonaws.com/Dev/gateway/profile?site_id=${site_id}`
      );
      const data = await response.json();
      return data[0]?.name;
    } catch (error) {
      console.error("Error fetching gateway name:", error.message);
      return null;
    }
  };

  const handleDialogClose = () => setDialogOpen(false);

  const handleSubmit = () => {
    setSiteData([]);
    setLoading(true);
    fetchSiteData().finally(() => {
      setLoading(false);
    });
    handleDialogClose();
  };

  const csvData = siteData.map((row) => {
    const csvRow = {};
    // Include all columns that exist in the data
    Object.keys(row).forEach((key) => {
      csvRow[key] = row[key] !== undefined ? row[key] : "N/A";
    });
    return csvRow;
  });
  const displayedRows = siteData.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const totalPages = Math.ceil(siteData.length / rowsPerPage);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Card>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
            <VuiTypography variant="lg" color="white">
              Data Export - {siteName}
            </VuiTypography>
            <div>
              <VuiButton
                variant="contained"
                color="secondary"
                onClick={() => setDialogOpen(true)}
                sx={{ mr: 2 }}
              >
                Edit
              </VuiButton>
              <CSVLink
                data={csvData}
                filename={`${siteName.replace(/\s+/g, "_")}_data_export_${new Date(
                  dateRange.startDate
                )
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}_to_${new Date(dateRange.endDate)
                  .toLocaleDateString("en-GB")
                  .replace(/\//g, "-")}.csv`}
                style={{ textDecoration: "none" }}
              >
                <VuiButton variant="contained" color="primary">
                  Download
                </VuiButton>
              </CSVLink>
            </div>
          </VuiBox>

          {loading ? (
            <VuiBox display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </VuiBox>
          ) : (
            <Table
              columns={generateTableColumns()}
              rows={displayedRows.map((row) => {
                const formattedRow = {};
                Object.keys(row).forEach((key) => {
                  formattedRow[key] = row[key] !== undefined ? row[key] : "N/A";
                });
                return formattedRow;
              })}
            />
          )}

          <VuiBox display="flex" justifyContent="center" p={2}>
            <VuiPagination>
              {totalPages > 1 && (
                <>
                  <VuiPagination
                    item
                    onClick={() => setPage(Math.max(1, page - 1))}
                    disabled={page === 1}
                  >
                    <Icon>keyboard_arrow_left</Icon>
                  </VuiPagination>

                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((num) => {
                      // Always show first, last, and the current page +/- 1
                      return (
                        num === 1 || num === totalPages || (num >= page - 1 && num <= page + 1)
                      );
                    })
                    .reduce((acc, num, index, arr) => {
                      if (index > 0 && num - arr[index - 1] > 1) {
                        acc.push("ellipsis");
                      }
                      acc.push(num);
                      return acc;
                    }, [])
                    .map((item, idx) =>
                      item === "ellipsis" ? (
                        <VuiPagination key={`ellipsis-${idx}`} item disabled>
                          ...
                        </VuiPagination>
                      ) : (
                        <VuiPagination
                          key={item}
                          item
                          active={page === item}
                          onClick={() => setPage(item)}
                        >
                          {item}
                        </VuiPagination>
                      )
                    )}

                  <VuiPagination
                    item
                    onClick={() => setPage(Math.min(totalPages, page + 1))}
                    disabled={page === totalPages}
                  >
                    <Icon>keyboard_arrow_right</Icon>
                  </VuiPagination>
                </>
              )}
            </VuiPagination>
          </VuiBox>
        </Card>
      </VuiBox>

      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Export Data from {siteName}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3} mt={1}>
            {/* Date & Time Range Inputs */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={dateRange.startDate}
                onChange={(e) => setDateRange((prev) => ({ ...prev, startDate: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="End Date & Time"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={dateRange.endDate}
                onChange={(e) => setDateRange((prev) => ({ ...prev, endDate: e.target.value }))}
              />
            </Grid>

            {/* Column Selection */}
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={selectAll} onChange={handleSelectAll} />}
                  label="Select All Columns"
                />
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "8px",
                    marginTop: "10px",
                  }}
                >
                  <Grid container spacing={1}>
                    {columnsOptions.map((column) => (
                      <Grid item xs={6} sm={4} key={column.value}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedColumns.some((col) => col.value === column.value)}
                              onChange={() => {
                                setSelectedColumns((prev) => {
                                  const exists = prev.find((col) => col.value === column.value);
                                  return exists
                                    ? prev.filter((col) => col.value !== column.value)
                                    : [...prev, column];
                                });
                              }}
                            />
                          }
                          label={column.label}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </FormGroup>
            </Grid>

            {/* Include Stocked Materials Option */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includeStockedMaterials}
                    onChange={() => setIncludeStockedMaterials(!includeStockedMaterials)}
                  />
                }
                label="Include Stocked Materials"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            disabled={
              !dateRange.startDate ||
              !dateRange.endDate ||
              (!selectedColumns.length && !includeStockedMaterials)
            }
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default DataExport;
